import styled, { css } from "styled-components";
import TitleIcon from "../assets/svg/custom-icon.svg?react";

const Container = styled("div")`
  background: white;
  padding: ${(props) => props.overridePadding || "0 16px 0 31px"};
  min-height: 90px;
  display: flex;
  align-items: center;
  color: ${({ lblColor, deactivated }) =>
    lblColor ? lblColor : deactivated ? "var(--grey600)" : "var(--grey900)"};
  border-bottom: 1px solid var(--grey150);
  height: 100%;
  ${(props) => css`
    color: var(--${props.deactivated ? "grey600" : "grey900"});
  `};
`;
const CompactContainer = styled("div")`
  display: flex;
  flex-grow: 1;
  align-items: center;
`;
const CompactTitle = styled("h2")`
  font-size: 14px;
  line-height: 1.5;
  margin-left: 20px;
  padding-bottom: 2px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-weight: 700;
`;
const CompactIconWrapper = styled("div")`
  width: 22px;
  height: 24px;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  svg {
    margin: 0px auto;
    color: ${(props) =>
      props.deactivated && !props.activeIcon
        ? "var(--disabled)"
        : "var(--grey900)"};
  }
`;

const AdditionalSubTitleWrapper = styled("div")`
  margin-bottom: -6px;
`;
const EllipsisParagraph = styled("p")`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const AddTitle = ({ deactivated, titleString, value, additionalSubTitle }) => (
  <Container deactivated={deactivated}>
    <CompactContainer>
      <CompactIconWrapper deactivated={deactivated}>
        <TitleIcon />
      </CompactIconWrapper>
      <CompactTitle deactivated={deactivated}>
        <EllipsisParagraph>{value || titleString}</EllipsisParagraph>
        <AdditionalSubTitleWrapper>
          {!value && additionalSubTitle}
        </AdditionalSubTitleWrapper>
      </CompactTitle>
    </CompactContainer>
  </Container>
);

export default AddTitle;
